export const MICROSECONDS_BASE = 1_000_000

export const DEFAULT_TELEMETRY_FLUSH_INTERVAL = 5000

export const DEFAULT_TELEMETRY_FLUSH_SIZE = 25

export const ORAMA_ANSWER_ENDPOINT = 'https://answer.api.orama.com'

export const MULTI_INDEX_BASE = '/v1/indexes'

export const LOCAL_STORAGE_USER_ID_KEY = 'orama_user_id'
export const LOCAL_STORAGE_SERVER_SIDE_SESSION_KEY = 'server-side-session'
